




















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { LocaleMessages } from "vue-i18n";
// components
import FunctionalCalendar from "vue-functional-calendar/src/components/FunctionalCalendar.vue";
import PowerPlanEventCreateAndUpdateModal from "@/components/powerPlans/modals/PowerPlanEventCreateAndUpdateModal.vue";
import PowerPlanEventDeleteModal from "@/components/powerPlans/modals/PowerPlanEventDeleteModal.vue";
// types
import { MarkedDay, RecurenceEnum, WeekdaysEnum } from "@/services/posts/types";
import { ActiveDaysRequest, PowerPlanEvent, PowerPlanEventFilter } from "@/services/powerPlans/types";
import i18n from "@/i18n";
import moment from "moment";
// service methods
import { getActiveDays, getPowerPlanEvents } from "@/services/powerPlans/powerPlanEventService";
import { calendarConfigs } from "@/services/functional-calendar";
import { powerPlanEventFields } from "@/components/powerPlans/fields/powerPlanEventFields";
import { powerPlanEventFromDate, powerPlanEventToDate } from "./powerPlanFormatting";

@Component({
    components: {
        PowerPlanEventCreateAndUpdateModal,
        FunctionalCalendar,
        PowerPlanEventDeleteModal
    }
})
export default class PowerPlanEvents extends Vue {
        @Prop() powerPlanId!: string;
        @Prop() collapseState!: boolean;
        // local state
        localCollapseState = true;
        localEvents = [] as PowerPlanEvent[];
        calendar = {} as any;
        markedDates = [] as Array<MarkedDay>;
        fields = powerPlanEventFields;
        isBusy = false;
        // filter options
        searchQuery = "";
        RecurenceEnum = RecurenceEnum;

        // calendar
        showCalendar = true;
        currentSelectedDate = new Date();

        // lifecycle hooks
        mounted() {
            this.localCollapseState = this.collapseState;
            this.loadActiveDays(this.firstDayOfThisMonth);
            this.fetchEvents(this.currentSelectedDate);
        }

        // watchers
        @Watch("showCalendar")
        onShowCalendarChanged(value: boolean, oldValue: any) {
            if (value) {
                this.fetchEvents(this.currentSelectedDate);
            } else {
                this.fetchEvents("");
            }
        }

        // computed
        get firstDayOfThisMonth(): Date {
            const today = new Date();
            const month = today.getMonth();
            const year = today.getFullYear();
            return new Date(year, month, 1);
        }

        get firstDayOfMonthOfSelectedDate(): Date {
            const month = this.currentSelectedDate.getMonth();
            const year = this.currentSelectedDate.getFullYear();
            return new Date(year, month, 1);
        }

        get filteredData() {
            return (
                this.localEvents &&
                this.localEvents.filter(
                    x =>
                        (this.searchQuery.length === 0 ||
                        x.name.toLowerCase().includes(this.searchQuery.toLowerCase()))));
        }

        get calendarConfigs() {
            return calendarConfigs();
        }

        // methods
        setState(state: boolean) {
            if (this.localCollapseState === state) return;

            this.localCollapseState = state;
            this.$emit("componentStateChanged", { name: "PowerPlanEvents", state: state });
        }

        fetchEvents(date: any) {
            getPowerPlanEvents({
                powerPlanId: this.powerPlanId,
                calendarDate: date.toLocaleString("en-US")
            } as PowerPlanEventFilter).then(response => {
                this.localEvents = response;
            });
        }

        loadActiveDays(startDate: Date) {
            getActiveDays({
                powerPlanId: this.powerPlanId,
                calendarStartDate: startDate
            } as ActiveDaysRequest).then(response => {
                let i;
                for (i = 0; i < this.markedDates.length; i++) {
                    Vue.set(this.markedDates, i, {});
                }
                response.forEach((date: string, i: number) => {
                    Vue.set(this.markedDates, i, {
                        date: date,
                        class: "vfc-marked"
                    });
                });
            });
        }

        reloadEventList() {
            if (this.showCalendar) {
                this.fetchEvents(this.currentSelectedDate);
            } else {
                this.fetchEvents("");
            }
            this.loadActiveDays(this.firstDayOfMonthOfSelectedDate);
        }

        toggleCalendar() {
            this.showCalendar = !this.showCalendar;
        }

        addEvent() {
            (this.$refs.eventCreateAndUpdateModal as any).resetForm();
            this.$bvModal.show("modal-powerPlanEventCreateAndUpdate");
        }

        // calendar events
        dayClicked(day: any) {
            const dateParts = day.date.split("/");
            // month is 0-based, that's why we need dataParts[1] - 1
            const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
            this.currentSelectedDate = dateObject;
            this.fetchEvents(dateObject);
        }

        changedMonth(startDate: Date) {
            this.loadActiveDays(startDate);
        }

        parseTime(value: string) {
            if (value.length === 5) {
                return value;
            }
            return moment(value).format("HH:mm");
        }

        getWeeklyRecurenceDays(event: PowerPlanEvent): (LocaleMessages | string)[] {
            if (event.recurenceType === RecurenceEnum.weekly) {
                return event.recurenceValues.map(dayOfTheWeek => {
                    switch (dayOfTheWeek) {
                    case WeekdaysEnum.monday:
                        return i18n.t("posts.monday");
                    case WeekdaysEnum.tuesday:
                        return i18n.t("posts.tuesday");
                    case WeekdaysEnum.wednesday:
                        return i18n.t("posts.wednesday");
                    case WeekdaysEnum.thursday:
                        return i18n.t("posts.thursday");
                    case WeekdaysEnum.friday:
                        return i18n.t("posts.friday");
                    case WeekdaysEnum.saturday:
                        return i18n.t("posts.saturday");
                    case WeekdaysEnum.sunday:
                        return i18n.t("posts.sunday");
                    }
                    throw new Error("Day of the week enum is out of bounds");
                });
            } else {
                return [];
            }
        }

        getMonthlyRecurenceDays(event: PowerPlanEvent): string {
            if (event.recurenceType === RecurenceEnum.monthly) {
                return event.recurenceValues.join(", ");
            } else {
                return "";
            }
        }

        getFromDateLabel(event: PowerPlanEvent) {
            return powerPlanEventFromDate(event);
        }

        getToDateLabel(event: PowerPlanEvent) {
            return powerPlanEventToDate(event);
        }

        removeEvent(event: PowerPlanEvent, name: string) {
            (this.$refs.powerPlanEventDeleteModal as any).open(event.id, event.name);
        }

        openEditEventPrompt(event: PowerPlanEvent) {
            event.fromTime = event.fromTime.length > 5 ? event.fromTime.split("T")[1].slice(0, -3) : event.fromTime;
            event.toTime = event.toTime.length > 5 ? event.toTime.split("T")[1].slice(0, -3) : event.toTime;

            (this.$refs.eventCreateAndUpdateModal as any).event = event;
            (this.$refs.eventCreateAndUpdateModal as any).isEdit = true;
            this.$bvModal.show("modal-powerPlanEventCreateAndUpdate");
        }
}
